import {
  cache_clear,
  cache_read,
  cache_write,
  person_cacheName,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export default class personSettingsClass {
  constructor(personId, token) {
    this.token = token;
    this.personId = personId;
    this.isLoaded = false;
    this.settings = [
      // {
      //   personSettingTypeId: 0,
      //   personSettingTypeText: undefined,
      //   personSettingTypeCategory: undefined,
      //   boolVar: false,
      //   intVar: 0,
      //   stringVar: "",
      //   timeVar: null,
      // },
    ];
  }

  async init() {
    let data = null;
    const addr = "/api/person/settings/get/" + this.personId;
    const fullUrl = import.meta.env.VITE_SERVER_URL + addr;
    const c = cache_read(person_cacheName, fullUrl);
    if (c) {
      data = c;
    } else {
      const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
          "x-access-token": `${this.token}`,
          "Content-Type": "application/json",
        },
      });
      const cResponse = await checkResponse(response, "personSettingsClass:init");
      if (!cResponse.success) return false;
      data = cResponse.data;
      cache_write(person_cacheName, fullUrl, data, 360);
    }

    if (data != null || data.length == 0) {
      this.settings = [];
      for (let i = 0; i < data.length; i++) this.settings.push(data[i]);
    }
    this.isLoaded = true;
  }

  getRoles() {
    const roles = [];
    this.settings.forEach((setting) => {
      if (setting.personSettingTypeCategory == "role") roles.push(setting);
    });
    return roles;
  }

  getSetting(personSettingTypeIds) {
    if (typeof personSettingTypeIds === "number") {
      // if a number is passed, fetch the setting with that id as array
      return this.getSetting([personSettingTypeIds]);
    } else {
      for (let i = 0; i < this.settings.length; i++) {
        for (let j = 0; j < personSettingTypeIds.length; j++) {
          if (this.settings[i].personSettingTypeId == personSettingTypeIds[j])
            return this.settings[i];
        }
      }
    }
    // return these default values if the setting is not found
    return {
      personSettingTypeId: personSettingTypeIds,
      boolVar: false,
      intVar: 0,
      stringVar: "",
      timeVar: null,
    };
  }

  async setSetting(personSettingTypeId, boolVar, intVar = null, stringVar = null, timeVar = null) {
    cache_clear(person_cacheName);
    await savePersonSettingToDB(
      this.personId,
      personSettingTypeId,
      this.token,
      boolVar,
      intVar,
      stringVar,
      timeVar
    );
    for (let i = 0; i < this.settings.length; i++)
      if (this.settings[i].personSettingTypeId == personSettingTypeId) {
        this.settings[i].boolVar = boolVar;
        this.settings[i].intVar = intVar;
        this.settings[i].stringVar = stringVar;
        this.settings[i].timeVar = timeVar;
      }
  }
  get isHelperEditor() {
    return this.getSetting(10).boolVar;
  }
  get isRoleManager() {
    return this.getSetting(9).boolVar;
  }
  get isSystemAdmin() {
    return this.getSetting(8).boolVar;
  }
  get isBetoniAdmin() {
    return this.getSetting(12).boolVar;
  }
  get isPumppuAdmin() {
    return this.getSetting(11).boolVar;
  }
  get isTuoteAdmin() {
    return this.getSetting(17).boolVar;
  }
  get isHinnastoAdmin() {
    return this.getSetting(18).boolVar;
  }
  get isLattiaAdmin() {
    return this.getSetting(13).boolVar;
  }
  get isDeveloper() {
    return this.getSetting(19).boolVar;
  }
  get isKeikkaAdmin() {
    // same as isAnyAdmin
    return this.getSetting([11, 8, 12, 13]).boolVar;
  }
  get oletusAdminYritysId() {
    const a = this.getSetting(15).intVar;
    return a;
  }
  async setOletusAdminYritysId(value) {
    await this.setSetting(15, true, value);
  }

  get isExtendedView() {
    return this.getSetting(21).boolVar;
  }
  async setIsExtendedView(value) {
    await this.setSetting(21, value);
  }
  get isAnyAdmin() {
    // same as isKeikkaAdmin
    return this.getSetting([11, 8, 12, 13]).boolVar;
  }
  get saaLähettääTilaustietoa() {
    return !this.getSetting(1).boolVar;
  }
  async setSaaLähettääTilaustietoa(value) {
    await this.setSetting(1, !value);
  }
  get saaLähettääMarkkinointipostia() {
    return this.getSetting(2).boolVar;
  }
  get saaJakaaMuille() {
    return this.getSetting(3).boolVar;
  }
  get hasMultipleKeikkas() {
    return this.getSetting(14).boolVar;
  }
  set hasMultipleKeikkas(value) {
    this.setSetting(14, value);
  }
  get defaultPersonPvmStatusId() {
    const a = this.getSetting(20);
    if (a?.boolVar) return a.intVar;
    else return 1; // default, töissä
  }
  set defaultPersonPvmStatusId(value) {
    this.setSetting(20, value > 0 ? true : false, value);
  }

  // default pumppuToimittajaAsiakas is which asiakas to
  // choose for pumppuToimittaja when nothing is selected
  get defaultPumpputoimittajaAsiakasId() {
    return this.getSetting(5).intVar;
  }
  async setDefaultPumpputoimittajaAsiakasId(value) {
    await this.setSetting(5, value, value);
  }
  // default betoniToimittajaAsiakas is which asiakas to
  // choose for betoniToimittaja when nothing is selected
  get defaultBetonitoimittajaAsiakasId() {
    return this.getSetting(6).intVar;
  }
  async setDefaultBetonitoimittajaAsiakasId(value) {
    await this.setSetting(6, value);
  }
  // default lattiaToimittajaAsiakas is which asiakas to
  // choose for lattiaToimittaja when nothing is selected
  get defaultLattiatoimittajaAsiakasId() {
    return this.getSetting(7).intVar;
  }
}

export async function fetchPersonSetting(personId, personSettingTypeId) {
  const addr = "/api/person/setting/get/" + personId + "/" + personSettingTypeId;
  const fullUrl = import.meta.env.VITE_SERVER_URL + addr;
  const c = cache_read(person_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      //"x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "personSettingsClass:fetchPersonSetting");
  if (!cResponse.success) return false;
  const data = cResponse.data;
  if (data == null || data.length == 0) {
    const _data = {
      personSettingTypeId: personSettingTypeId,
      boolVar: false,
      intVar: 0,
      stringVar: "",
      timeVar: null,
    };
    cache_write(person_cacheName, fullUrl, _data);
    return _data;
  } else {
    cache_write(person_cacheName, fullUrl, data[0], 360);
    return data[0];
  }
}
export async function savePersonSettingToDB(
  personId,
  personSettingTypeId,
  token,
  boolVar,
  intVar = null,
  stringVar = null,
  timeVar = null
) {
  const addr = "/api/person/settings/set/";
  const fullUrl = import.meta.env.VITE_SERVER_URL + addr;
  cache_clear(person_cacheName);
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personSettingTypeId: personSettingTypeId,
      personId: personId,
      boolVar: boolVar,
      intVar: intVar,
      stringVar: stringVar,
      timeVar: timeVar,
    }),
  });
  return response.ok;
}

export async function fetchAllRoles(token) {
  try {
    const addr = "/api/person/settings/getAllRoles/";
    const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "personSettingsClass:fetchAllRoles");
    return cResponse;
  } catch (e) {
    console.log("personSettingsClass:fetchAllRoles");
    console.log(e);
    return false;
  }
}
